import PageLayout from '../shared/PageLayout/PageLayout';
import FitnessPage from './shared/FitnessPage';

const WelcomePacket = () => {
	const pageTitle = 'Welcome Packet';
	const pageId = 'welcome-packet'; // Content Owners need to create a fitness page with this ID

	return (
		<PageLayout pageTitle={pageTitle}>
			<FitnessPage pageId={pageId} />
		</PageLayout>
	);
};

export default WelcomePacket;
